import { getSettings } from 'utils/settings';

const ALL_HEADERS = [
  {
    key: 'curp',
    order: 1,
    pathname: '/request/curp',
    hash: {
      '': {
        subheader: 'Ingresa la CURP del cliente para continuar',
        title: 'Búsqueda de cliente',
      },
    },
    step: 'CURP',
  },
  {
    key: 'identity',
    order: 1,
    pathname: [
      '/request/accessories/identity',
      '/request/iphone/identity',
      '/request/identity',
    ],
    hash: {
      '': {
        subheader: 'Puedes continuar tu proceso en tu dispositivo telefónico o continuar en tu computadora',
        title: 'Validación de identidad',
      },
      external: {
        addPercentage: 16,
        subheader: 'Escanea este código con la camara de tu dispositivo para iniciar con el proceso de verificación',
        title: 'Continúa el proceso en tu teléfono',
      },
      internal: {
        addPercentage: 16,
        subheader: 'A continuación se abrirá automáticamente una ventana emergente para continuar con tu validación',
        title: 'Continúa el proceso en tu computadora',
      },
    },
    step: 'Verificación de identidad',
  },
  {
    key: 'score',
    hash: {
      bad: {
        align: 'center',
        subheader: 'Recuerda que puedes volver a solicitar un crédito posterior a 30 días de este momento, te estaremos esperando',
        title: '¡Lo sentimos, tu score crediticio no cumple!',
      },
      good: {
        align: 'center',
        subheader: '',
        title: '¡Felicidades, tu score crediticio es bueno! 🥳',
      },
      existing_user: {
        align: 'center',
        subheader: 'Hemos detectado que ya cuentas con un crédito activo, por lo que no es posible continuar con el proceso.',
        title: '¡Crédito existente! 🛑',
      },
    },
    isVisible: true,
    order: 2,
    pathname: '/request/score',
    step: 'Score',
  },
  {
    key: 'info',
    hash: {
      '': {
        align: 'center',
        subheader: 'Verifica y completa los datos faltantes',
        title: 'Datos del cliente',
      },
    },
    isVisible: true,
    pathname: '/request/info',
    step: 'Verificación de datos',
    order: 3,
  },
  {
    key: 'loan_device',
    hash: {
      '': {
        subheader: '',
        title: 'Datos del crédito',
      },
    },
    isVisible: true,
    pathname: '/request/loan_device',
    step: 'Crédito',
    order: 5,
  },
  {
    key: 'relationships',
    hash: {
      '': {
        subheader: '',
        title: 'Referencias personales',
      },
    },
    isVisible: false,
    pathname: '/request/relationships',
    order: 4,
    step: 'Referencias',
  },
  {
    key: 'enrollment',
    hash: {
      '': {
        subheader: 'Ingresa los datos del teléfono donde se colocará el candado',
        title: 'Ahora compártenos la siguiente información',
      },
    },
    order: 6,
    pathname: [
      '/request/enrollment',
      '/request/enrollment_datacultr',
    ],
    percentage: 77,
    step: 'Ingresa IMEI',
  },
  {
    key: 'confirm_enrollment',
    hash: {
      '': {
        title: 'Realiza los siguientes pasos:',
        subheader: 'Al terminar, espera un par de segundos',
      },
      tac_no_exist: {
        title: 'TAC no existe',
        subheader: 'El código TAC del dispositivo no se encuentra registrado en el sistema',
      },
    },
    order: 7,
    pathname: '/request/confirm_enrollment',
    percentage: 77,
    step: 'Enrolamiento del dispositivo',
  },
  {
    key: 'evidence',
    hash: {
      '': {
        subheader: 'Toma la foto del cliente con el teléfono en mano y aplicación abierta con su INE',
        title: 'Evidencia',
      },
    },
    pathname: '/request/evidence',
    order: 8,
    step: 'Evidencia',
  },
  {
    key: 'evidence_ticket',
    hash: {
      '': {
        subheader: 'Toma la foto de comprobante de domicilio reciente',
        title: 'Evidencia de comprobante',
      },
    },
    pathname: '/request/evidence_ticket',
    order: 8,
    step: 'Evidencia De Comprobante',
  },
  {
    key: 'lockunlock',
    hash: {
      '': {
        title: 'Ahora puedes probar el candado en el equipo (opcional)',
        subheader: '',
      },
    },
    order: 9,
    pathname: [
      '/request/lockunlock',
      '/request/lockunlock_datacultr',
    ],
    step: 'Bloqueo y Desbloqueo de dispositivo',
  },
  {
    key: 'contract',
    hash: {
      '': {
        subheader: 'Necesitamos tu aprobación para finalizar el registro',
        title: 'Por último, acepta el contrato',
      },
    },
    order: 10,
    pathname: '/request/contract',
    step: 'Contrato',
  },
  {
    key: 'finished',
    hash: {
      '': {
        align: 'center',
        subheader: 'Ahora puedes disfrutar de los beneficios que tenemos para ti.',
        title: '¡Proceso concluido con éxito! 👍',
      },
    },
    pathname: '/request/finished',
    order: 11,
    step: '¡Finalizado!',
  },
  {
    key: 'blocked_user',
    hash: {
      '': {
        align: 'center',
        subheader: 'No es posible procesar tu pago debido a registros de impago asociados a tu cuenta. Te invitamos a regularizar tu situación para continuar con el proceso.',
        title: 'Solicitud cancelada',
      },
      user_exists: {
        align: 'center',
        subheader: 'La identificación o CURP que ingresaste ya cuenta con un producto activo. Inicia sesión para continuar con la gestión de tu cuenta.',
        title: 'Usuario ya registrado',
      },
    },
    isVisible: false,
    order: 1,
    pathname: '/request/blocked_user',
    step: 'Usuario bloqueado',
  },
  {
    key: 'status',
    hash: {
      accepted: {
        align: 'center',
        title: '¡Felicidades, tu crédito ha sido aprobado! 🎊',
      },
      rejected: {
        align: 'center',
        title: '¡Lo sentimos, tu crédito ha sido rechazado! 😥',
      },
    },
    isVisible: false,
    order: 6,
    pathname: '/request/status',
    step: 'Registro',
  },
  {
    key: 'confirm_identity',
    hash: {
      '': {
        title: 'Confirma tus datos',
      },
    },
    isVisible: false,
    order: 1,
    pathname: '/request/confirm_identity',
    step: 'Confirma tus datos',
  },
  {
    key: 'products',
    hash: {
      '': {
        align: 'center',
        subheader: 'Ingresa los productos que deseas adquirir',
        title: 'Productos',
      },
    },
    isVisible: false,
    pathname: '/request/products',
    step: 'Productos',
  },
  {
    key: 'device',
    hash: {
      '': {
        align: 'center',
        subheader: 'Ingresa los datos del teléfono donde se colocará el candado',
        title: 'Ahora compártenos la siguiente información',
      },
    },
    isVisible: false,
    pathname: '/request/device',
    step: 'Dispositivo',
  },
  {
    key: 'verify',
    hash: {
      '': {
        align: 'center',
        subheader: 'Haz concluido el proceso de la instalación del candado, ahora vamos a probar el candado.',
        title: 'Validaremos el candado',
      },
    },
    isVisible: false,
    pathname: '/request/verify',
    order: 5,
    step: 'Validación',
  },
  {
    hash: {
      '': {
        align: 'center',
        subheader: 'Tuvimos problemas al extraer la información del usuario. Puedes intentarlo nuevamente.',
        title: 'Reintentar verificación ⚠️',
      },
    },
    isVisible: false,
    order: 1,
    pathname: '/request/retry',
    step: 'Verificación de identidad',
  },
];

export const getHeaders = () => {
  const steps = getSettings('step', []);
  const visibleSteps = getSettings('isVisibleStep', []);
  
  if (!steps || steps.length === 0) {
    return [...ALL_HEADERS];
  }

  return ALL_HEADERS.map((header) => {
    const stepIndex = steps.indexOf(header.key);
    const isVisible = visibleSteps.includes(header.key);
    
    return {
      ...header,
      isVisible,
      order: stepIndex !== -1 ? stepIndex + 1 : header.order,
    };
  });
};

export const HEADERS = getHeaders();

export const getNextStep = (currentStepKey) => {
  const steps = getSettings('step', []);
  if (!steps || steps.length === 0) {
    return null;
  }

  const currentIndex = steps.indexOf(currentStepKey);
  if (currentIndex === -1 || currentIndex === steps.length - 1) {
    return null;
  }

  return steps[currentIndex + 1];
};

export const getPrevStep = (currentStepKey) => {
  const steps = getSettings('step', []);
  if (!steps || steps.length === 0) {
    return null;
  }

  const currentIndex = steps.indexOf(currentStepKey);
  if (currentIndex === -1 || currentIndex === 0) {
    return null;
  }

  return steps[currentIndex - 1];
};

export const getCurrentStepIndex = (currentStepKey) => {
  const steps = getSettings('step', []);
  if (!steps || steps.length === 0) {
    return -1;
  }

  return steps.indexOf(currentStepKey);
};
export const getCurrentVisibleStep = (currentStepOrder, visibleHeaders = null) => {
  if (!visibleHeaders) {
    const headers = HEADERS.filter((header) => header.isVisible !== false);
    visibleHeaders = headers.sort((a, b) => a.order - b.order);
  }

  if (currentStepOrder <= visibleHeaders[0].order) {
    return visibleHeaders[0].order;
  }

  if (currentStepOrder >= visibleHeaders[visibleHeaders.length - 1].order) {
    return visibleHeaders[visibleHeaders.length - 1].order;
  }

  for (let i = 0; i < visibleHeaders.length; i++) {
    const header = visibleHeaders[i];
    const nextHeader = visibleHeaders[i + 1];

    if (currentStepOrder === header.order) {
      return header.order;
    }

    if (nextHeader && currentStepOrder > header.order && currentStepOrder < nextHeader.order) {
      return nextHeader.order;
    }
  }

  return currentStepOrder;
};

export const getNextVisibleStep = (currentStepKey) => {
  const steps = getSettings('step', []);
  const visibleSteps = getSettings('isVisibleStep', []);
  
  if (!steps || steps.length === 0) {
    return null;
  }

  const currentIndex = steps.indexOf(currentStepKey);
  if (currentIndex === -1) {
    return null;
  }

  for (let i = currentIndex + 1; i < steps.length; i++) {
    if (visibleSteps.includes(steps[i])) {
      return steps[i];
    }
  }

  return null;
};

export const getPrevVisibleStep = (currentStepKey) => {
  const steps = getSettings('step', []);
  const visibleSteps = getSettings('isVisibleStep', []);
  
  if (!steps || steps.length === 0) {
    return null;
  }

  const currentIndex = steps.indexOf(currentStepKey);
  if (currentIndex === -1 || currentIndex === 0) {
    return null;
  }

  for (let i = currentIndex - 1; i >= 0; i--) {
    if (visibleSteps.includes(steps[i])) {
      return steps[i];
    }
  }

  return null;
};

export const getCurrentVisibleStepIndex = (currentStepKey) => {
  const steps = getSettings('step', []);
  const visibleSteps = getSettings('isVisibleStep', []);
  
  if (!steps || steps.length === 0) {
    return -1;
  }

  const currentIndex = steps.indexOf(currentStepKey);
  if (currentIndex === -1) {
    return -1;
  }

  let visibleIndex = -1;
  for (let i = 0; i <= currentIndex; i++) {
    if (visibleSteps.includes(steps[i])) {
      visibleIndex++;
    }
  }

  return visibleIndex;
};

